import { render, staticRenderFns } from "./RankingUnchanged.vue?vue&type=template&id=679055a3&scoped=true&"
import script from "./RankingUnchanged.vue?vue&type=script&lang=js&"
export * from "./RankingUnchanged.vue?vue&type=script&lang=js&"
import style0 from "./RankingUnchanged.vue?vue&type=style&index=0&id=679055a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679055a3",
  null
  
)

export default component.exports